import packageJson from "../../../package.json";

export function Health() {
  return (
    <div>
      {`Version is "${packageJson.version}" (${process.env.REACT_APP_GIT_SHA || "dev"})`}
    </div>
  );
}
